// extracted by mini-css-extract-plugin
export default {"container":"Words_container__wLU9f","title":"Words_title__1--AJ","subtitle":"Words_subtitle__W2ooa","wordsContainer":"Words_wordsContainer__jGhyf","word":"Words_word__z7wmv"};